import React, { useEffect, useState } from 'react';
import config from '../../../../settings/config';
import styles from './StartButton.module.css';
import localeRu from '../../../../locales/ru/stations/stationControl.json';
import localeEn from '../../../../locales/en/stations/stationControl.json';
import { toast } from "react-toastify";

const StartButton = ({ status, station }) => {
    let lang = localStorage.getItem('language') === 'ru';
    const slaveId = 1;

    const [connector, setConnector] = useState(station?.connectors[0]);

    const [isPushButton, setIsPushButton] = useState(false);
    const [textButton, setTextButton] = useState(lang ? localeRu.start_charging : localeEn.startCharging);
    const [styleButton, setStyleButton] = useState(styles.submitStartCharging);

    const [timer, setTimer] = useState(0);

    useEffect(() => {
        let countdown;
        if (isPushButton) {
            setTimer(90); // старт отсчета с 90
            countdown = setInterval(() => {
                setTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(countdown);
                        setIsPushButton(false); // по истечении таймера выключаем кнопку
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => clearInterval(countdown); // очистка таймера при размонтировании/перезапуске
    }, [isPushButton]);

    useEffect(() => {
        if ((status === "Available" || status === "Preparing") && isPushButton) {
            if (station?.autoCharge) {
                setTextButton(lang ? localeRu.autoCharge : localeEn.autoCharge);
                setStyleButton(styles.submitPushButton);
            } else {
                setTextButton(lang ? localeRu.waitForStart : localeEn.waitForStart);
                setStyleButton(styles.submitPushButton);
            }

        } else if ((status === "Available" || status === "Preparing") && !isPushButton) {
            if (station?.autoCharge) {
                setTextButton(lang ? localeRu.autoCharge : localeEn.autoCharge);
                setStyleButton(styles.submitPushButton);
            } else {
                setTextButton(lang ? localeRu.start_charging : localeEn.startCharging);
                setStyleButton(styles.submitStartCharging);
            }
        } else if (status === "Charging") {
            setTextButton(lang ? localeRu.stopCharging : localeEn.stopCharging);
            setStyleButton(styles.submitStartCharging);
            setIsPushButton(false);

        } else if (status === "Finishing" && isPushButton) {
            setTextButton(lang ? localeRu.waitForStart : localeEn.waitForStart);
            setStyleButton(styles.submitPushButton);
        } else if (status === "Finishing" && !isPushButton) {
            setTextButton(lang ? localeRu.repeatCharging : localeEn.repeatCharging);
            setStyleButton(styles.submitStartCharging);
        } else if (status === "Faulted" && !isPushButton) {
            setTextButton(lang ? localeRu.errorEndCharging : localeEn.repeatCharging);
            setStyleButton(styles.submitPushButton);
        } else {
            setTextButton(lang ? localeRu.stopCharging : localeEn.stopCharging);
            setStyleButton(styles.submitStartCharging);
        }
    }, [status, isPushButton, lang]);

    async function requestStartCharging() {
        try {
            const response = await fetch(`${config.app.host}/api/v1/station/start?sn=${station?.sn}&maxP=1&maxC=1&slaveId=${slaveId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('m_token')}`,
                },
            });

            const responseData = await response.json();

            toast.success(status === "Available" ?
                (lang ? localeRu.startChargingSession : localeEn.startChargingSession) :
                (lang ? localeRu.startChargingSessionPre : localeEn.startChargingSessionPre), {
                position: "top-center",
                autoClose: 3000,
                style: { color: "white", backgroundColor: "black" },
            });


            if (!response.ok) {
                const errorMessage = responseData?.message || 'Неизвестная ошибка';
            }
        } catch (error) {
        }
    }

    async function requestStopCharging() {
        try {
            const response = await fetch(`${config.app.host}/api/v1/station/stop?sn=${station.sn}&slaveId=${slaveId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('m_token')}`,
                },
            });

            const responseData = await response.json();

            toast.success(lang ? localeRu.stopChargingSession : localeEn.stopChargingSession, {
                position: "top-center",
                autoClose: 3000,
                style: { color: "white", backgroundColor: "black" },
            });

            if (!response.ok) {
                const errorMessage = responseData?.message || 'Неизвестная ошибка';
            }
        } catch (error) {
        }
    }

    const handlePushButton = () => {
        if (isPushButton) return;
        if (status === "Faulted") {
            toast.success(lang ? localeRu.errorInfoToast : localeEn.errorInfoToast, {
                position: "top-center",
                autoClose: 3000,
                style: { color: "white", backgroundColor: "black" },
            });
            return;
        }
        
        if (station?.autoCharge && (status !== "Charging" && status !== "Finishing")) {
            toast.success(lang ? localeRu.autoChargeEnabled : localeEn.autoChargeEnabled, {
                position: "top-center",
                autoClose: 3000,
                style: { color: "white", backgroundColor: "black" },
            });
            return;
        }

        if (status === "Charging") {
            requestStopCharging();
        } else {
            setIsPushButton(true);
            requestStartCharging();
        }
    };

    return (
        <div className={styles.sectionButton}>
            <button
                type="button"
                className={styleButton}
                onClick={handlePushButton}
            >
                <p className={styles.textButtons}>{textButton}</p>
            </button>
        </div>
    )
}

export default StartButton;